import { Link } from "react-router-dom";
import { getNicheMeta } from "./nicheMeta";
import { NicheIcon } from "./NicheIcons";

/**
 * @param {{ nicheKey: string, to: string, label?: string, className?: string }} props
 */
export function NicheBrowseTile({ nicheKey, to, label, className = "" }) {
  const meta = getNicheMeta(nicheKey);

  return (
    <Link
      to={to}
      className={`niche-browse-tile ${meta.tileClass}${className ? ` ${className}` : ""}`}
    >
      <div className="niche-browse-icon">
        <NicheIcon niche={meta.key} size="md" />
      </div>
      <div className="niche-browse-name">{label ?? meta.browseLabel ?? meta.label}</div>
    </Link>
  );
}
